import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import { InputGeneralComponent } from 'app/components/input-general/input-general.component';
import { SelectGeneralComponent } from 'app/components/select-general/select-general.component';
import { HomePageService } from '../home/home.service';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { News } from '../home/home.types';
import moment from 'moment';
import { DateAgoPipe } from 'app/core/pipes/date-ago.pipe';
import { MatMenuModule } from '@angular/material/menu';

@Component({
    selector: 'blog-list',
    templateUrl: './blog-list.component.html',
    imports: [
        HeaderComponent,
        FooterComponent,
        InputGeneralComponent,
        SelectGeneralComponent,
        TranslateModule,
        CommonModule,
        MatMenuModule,
        RouterModule,
    ],
    standalone: true,
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class BlogListComponent {
    newsDetails: any;
    showNews: News[];
    showMainNews;
    showSubNews;
    showAllNews;
    showMainNewsTimeAgo: any;
    timeAgo;
    clickedOutside: boolean = false;

    constructor(
        private homepageService: HomePageService,
        public datepipe: DatePipe
    ) {}

    ngOnInit() {
        this.homepageService.getNewsHome().subscribe((data: any) => {
            if (data.length > 0) {
                this.showAllNews = data;
                this.showAllNews.forEach((element: any) => {
                    element.timestamp = this.calculateAllNewsTime(
                        element.timestamp,
                    );
                });

                const newsMainData = this.showAllNews.filter(
                    (item: any) => item.displayPosition == 1,
                );
                this.showMainNews = newsMainData;

                let newsSubData = this.showAllNews.filter(
                    (item: any) => item.displayPosition > 1,
                );

                newsSubData.sort(
                    (a, b) =>
                        Number(a.displayPosition) - Number(b.displayPosition),
                );

                newsSubData = newsSubData.slice(0, 3);

                this.showSubNews = newsSubData;
            }
        });
    }

    onSortNews(newsOrder) {
        this.homepageService.getNewsHome().subscribe((data: any) => {
            if (data.length > 0) {
                let newsDetailsData = data;
                newsDetailsData.forEach((element: any) => {
                    element.timestamp = this.calculateAllNewsTime(
                        element.timestamp,
                    );
                });

                if (newsOrder == 'old') {
                    newsDetailsData.sort((a, b) => Number(a.id) - Number(b.id));
                }

                this.showAllNews = newsDetailsData;
            }
        });
    }

    calculateAllNewsTime(allNewsTimeValue) {
        let startDate: any = new Date(allNewsTimeValue);

        let dateAgoPipe = new DateAgoPipe();

        let dateToCompare = moment(startDate, 'DDMMYYYY');
        let today = moment().startOf('day'); // At midnight earlier today

        if (dateToCompare < today) {
            let date = this.datepipe.transform(startDate, 'dd/MM/yyyy');
            return (allNewsTimeValue = date);
        } else {
            let date = dateAgoPipe.transform(startDate);
            return (allNewsTimeValue = date);
        }
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }
}
